import { BiArrowFromBottom } from "react-icons/bi";

import { OneSideSwitcher } from "../../form-components/components/OneSideSwitcher";

export const StakeSwitcher = () => (
  <OneSideSwitcher icon1={<BiArrowFromBottom size={18} />} title1="Unstake" />
);
